(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var observer = null;

  function play(video) {
    if (reduceMotion) {
      video.pause();
      return;
    }
    var pending = video.play();
    if (pending && typeof pending.catch === 'function') {
      pending.catch(function () {});
    }
  }

  function watch(video) {
    if (!observer) {
      play(video);
      return;
    }
    observer.observe(video);
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(entry.target);
          } else {
            entry.target.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
  }

  function watchAll(root) {
    (root || document).querySelectorAll('[data-davai-video]').forEach(watch);
  }

  function setupMarquee(root) {
    var track = root.querySelector('.davai-marquee__track');
    if (!track || track.dataset.marqueeReady === 'true') return;
    track.dataset.marqueeReady = 'true';

    var seconds = parseFloat(root.getAttribute('data-seconds')) || 12;
    var minGap = 12;

    function layout() {
      var container = root.clientWidth;
      if (container && root.dataset.marqueeWidth === String(container) && root.classList.contains('is-running')) return;

      track.querySelectorAll('[data-marquee-clone]').forEach(function (node) {
        node.remove();
      });

      var items = Array.prototype.slice.call(track.children).filter(function (node) {
        return node.classList.contains('davai-marquee__item');
      });

      items.forEach(function (item) {
        item.style.position = '';
        item.style.left = '';
        item.style.top = '';
      });
      track.style.height = '';
      track.style.width = '';
      root.classList.remove('is-running');
      root.style.removeProperty('--davai-marquee-shift');
      root.dataset.marqueeWidth = '';

      if (!items.length || reduceMotion || designMode || !container) return;

      var widths = items.map(function (item) {
        return item.getBoundingClientRect().width;
      });
      var contentWidth = widths.reduce(function (sum, width) {
        return sum + width;
      }, 0);
      var packedWidth = contentWidth + minGap * items.length;
      var gap = packedWidth >= container ? minGap : (container - contentWidth) / items.length;
      var period = contentWidth + gap * items.length;

      var cursor = 0;
      items.forEach(function (item, index) {
        item.style.position = 'absolute';
        item.style.top = '0';
        item.style.left = cursor + 'px';

        var clone = item.cloneNode(true);
        clone.setAttribute('data-marquee-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.style.left = (cursor + period) + 'px';
        track.appendChild(clone);
        watchAll(clone);

        cursor += widths[index] + gap;
      });

      track.style.height = items[0].offsetHeight + 'px';
      track.style.width = (period + contentWidth) + 'px';

      var itemWidth = widths[0] || 1;
      root.style.setProperty('--davai-marquee-duration', (seconds * (period / itemWidth)) + 's');
      root.style.setProperty('--davai-marquee-shift', period + 'px');
      root.classList.add('is-running');
      root.dataset.marqueeWidth = String(container);
    }

    layout();

    if ('ResizeObserver' in window) {
      new ResizeObserver(layout).observe(root);
    } else {
      window.addEventListener('resize', layout);
    }
  }

  function start(root) {
    watchAll(root);
    (root || document).querySelectorAll('.davai-marquee').forEach(setupMarquee);
  }

  start(document);

  document.addEventListener('shopify:section:load', function (event) {
    start(event.target);
  });
})();
